<template>
  <div>
    <vue-datepicker
      ref="vueDatepicker"
      v-bind="datepicker"
      v-model="datepicker.value"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import VueDatepicker from "vuejs-datepicker";
import { de } from "vuejs-datepicker/dist/locale";

export default {
  name: "Datepicker",
  components: {
    VueDatepicker
  },
  props: {
    inputFullWidth: Boolean,
  },
  data() {
    return {
      input: null,
      datepicker: {
        inputClass: "form__input" + (this.inputFullWidth ? " width-100" : ""),
        format: "dd. MMMM yyyy",
        language: de,
        value: new Date(),
        ...this.$attrs
      }
    };
  }
};
</script>
<style>
.width-100 {
  width: 100%;
}
</style>
